import RestLink from './RestLink/RestLink';
export default function createRestLink(unionObjectTypesMap, queryEndpointsToBeRequestedWithPost, shadowComparisonOperationsV1ToV2) {
    return new RestLink(unionObjectTypesMap, queryEndpointsToBeRequestedWithPost, shadowComparisonOperationsV1ToV2);
}

//# sourceMappingURL=createRestLink.js.map